export default __webpack_public_path__ + "static/media/timbertech-wood-materials.a5ed0b01.csv";